import { Vibration } from 'react-native';

// Short tactile confirmation for key field actions (gloved/outdoor use);
// mirrors the existing scan and restock vibration feedback.
export const vibrateConfirm = () => {
	Vibration.vibrate(50);
};
